/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { getLoginLink } from "../../pages/login/sso-utils";
import "./styles.m.css";
import { getTextContrast } from "../../../utils";

export const SignInMessage = () => {
  const member = useSelector((state) => get(state, ["member"]));
  const enableDarkMode = useSelector((state) => get(state, ["header", "isDarkModeEnabled"], false));
  const {
    localization = {},
    sso = {},
    darkPrimaryColor,
    primaryColor = "#4860BC",
  } = useSelector((state) => get(state, ["qt", "config", "pagebuilder-config", "general"], {}));
  const sketchesHost =  useSelector((state) => get(state, ["qt", "config", "sketches-host"], ""));
  const loginButtonColor = useSelector((state) =>
    enableDarkMode
      ? get(
          state,
          ["qt", "config", "pagebuilder-config", "login", "pageSetting", "darkButtonColor"],
          darkPrimaryColor || "#4860BC"
        )
      : get(state, ["qt", "config", "pagebuilder-config", "login", "pageSetting", "buttonColor"], primaryColor)
  );
  const whiteListedUrlParams = useSelector((state) => get(state, ["qt", "config", "pagebuilder-config", "general", "others", "whiteListedUrlParams"], []));
  const textColor = getTextContrast(loginButtonColor);
  const { enableLocalization = false, localizedElements = {} } = localization;
  const { signInSignUp = {}, myProfile = {} } = enableLocalization ? localizedElements : {};
  const { signIn: localizedSignIn } = signInSignUp;
  const { signInMessage: localizedSignInMsg } = myProfile;
  return (
    <div styleName="info-message-wrapper">
      <h3>{localizedSignInMsg || "You must sign in to access this page."}</h3>
      <div styleName={`button ${textColor}`} onClick={() => getLoginLink(member, sso, sketchesHost, whiteListedUrlParams)}>
        {localizedSignIn || "Sign In"}
      </div>
    </div>
  );
};
